export enum FiDeviceType {
    None = 0,
    Phone = 1,
    Tablet = 2,
    Desktop = 3,
    MobileApp = 4,
}
